// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LoadingView_wrapper__3NjAQ","loader":"LoadingView_loader__pCVJo","spin":"LoadingView_spin__P5j8_"};